import React, {useEffect, useState} from 'react';
// import styled from 'styled-components'


//===IMPORT STYLES=====
import {
DashContent,
DashHead,
DashHeadCaption,
DashTable,
DashContainer,
Page,

} from './walletConnectStyles'

import {
  LinkIcon
} from '../RentWearable/rentWearableStyles'

//===IMPORT COMPONENT====

import {
Wrapper, 
Left, 
Right,
DashIconContainer,
Link, 
LeftCaption, 
DashLogo, 
DashIcons,
} from '../../components/dashboardBar/dashboardBarStyle'

import {
ProfileInfo,
WalletAddress
} from '../../components/dashboardBar2/dashboardBar2Styles'

import{
  ExportTable,
  ExportPdf,
  DashSelectRight,
  DashInputWrapper,
  DashInputImg,
  DashInputText,
  DashOptionWrapper,
  DashSelectWrapper,
  DashInput,
  DashInputOption,
  } from '../Player Dashboard/playerDashboardStyles'


import Content from '../../components/table/Content/Content';
import {Dash} from '../../components/dashboardBar/DashboardBar'
import Rentals from '../../icons/dashboardBarIcons/Rentals';
import Message from '../../icons/dashboardBarIcons/Message';
import image from '../../icons/dashboardBarIcons/BlueLogo.png'
import { useTranslation } from 'react-i18next';
import ResponsiveDashBar from '../../components/ResponsiveBar/ResponsiveDashBar';
import styled from 'styled-components';
import ProfileCard from '../../components/PopUps/profileCard/ProfileCard'
import WalletConnect from '../../components/ConnectionNav/Connect';
import Account from '../../icons/dashboardBarIcons/Account';
import arrow from '../../assets/vuesax-linear-arrow-down.svg'
import Pdf from "react-to-pdf";
import NotificationIcon from '../../icons/dashboardBarIcons/NotificationIcon';
import RentPopup from '../../components/PopUps/RentPopup/RentPopup';
import EmailPopup from '../../components/PopUps/EmailPopup/EmailPopup';
import RentalsPopup from '../../components/PopUps/RentalsPopup/RentalsPopup';
import Notifications from '../../components/PopUps/NotiicationDropDown/NotificationDropDown';

const ref = React.createRef();


export const Icon = styled.img`
  width:24px;
  height:24px;


`




const Page6 = () => {
  const { t } = useTranslation();

  const [display, setDisplay] = useState('none');
  const [rentalsDisplay, setRentalsDisplay] = useState('none');
  const [messageDisplay, setMessageDisplay] = useState('none');
  const [notificationDisplay, setNotificationDisplay] = useState('none')
  const [rentsDisplay, setRentDisplay] = useState('none')

  const [degree , setDegree] = useState('100%');
  const [rotate, setRotate] = useState('0deg');
  const [sortDrop, setSortDrop] = useState('none');
  const [sortTable, setSortTable] = useState('level');


  const Click = () => {
 
    if(display === 'none'){
      setDisplay('flex');
      setDegree('50%');
      console.log('Clicked Account');
    }else{
      setDegree('100%');
      setDisplay('none');
    }

  }
  const MessageClick = () => {
    if(messageDisplay === 'none'){
      setMessageDisplay('flex');
      setDegree('50%');
    }else{
      setDegree('100%');
      setMessageDisplay('none');
    }
  }

  const TableRentClick = () =>{
    if(rentsDisplay === 'none'){
      setRentDisplay('flex');
      setDegree('50%');
    }else{
      setDegree('100%');
      setRentDisplay('none');
    }
  }

  const RentalClick = () =>{
    if(rentalsDisplay === 'none'){
      setRentalsDisplay('flex');
      setDegree('50%');
    }else{
      setDegree('100%');
      setRentalsDisplay('none');
    }
  }

  const NotificationIconClick = () => {
    if(notificationDisplay === 'none'){
      setNotificationDisplay('flex');
      setDegree('50%');
    }else{
      setNotificationDisplay('none');
      setDegree('100%');
    }
  }

  const CancelRentals = () =>{
    setRentDisplay('none');
    setDegree('100%')
  }
  const CancelMessage = () => {
    setMessageDisplay('none');
    setDegree('100%')
  }

  const Clear = () => {
    setDegree('100%')
    setDisplay('none');
    setMessageDisplay('none');
    setRentalsDisplay('none');
    setRentDisplay('none');
    setNotificationDisplay('none')
  }

  const SortClick = () => {
    if(sortDrop === 'none'){
      setSortDrop('block')
      setRotate('180deg')
    } else{
      setSortDrop('none')
      setRotate('0deg')
    }
  }


  useEffect(() =>{
    const container = document.querySelector('#container')
    if(degree === '50%'){
      container.addEventListener('click', Clear );
      console.log(degree);
    }else if(degree === '100%'){
      container.removeEventListener('click', Clear);
      console.log(degree);
    }
    const sortName = document.querySelector('#sortName')
    const sort = document.querySelectorAll('.sort');
    const sortLists = sort.length;
    for (let i = 0; i < sortLists; i++) {
      sort[i].addEventListener('click', (event) => {
        setSortTable(event.target.value)
        let filter = event.target.value
        if(filter === 'level'){
          sortName.innerHTML= 'Sort by : Level Or Rank';
          setSortDrop('none');
        }
        if(filter === 'multiplier'){
          sortName.innerHTML= 'Sort by : Multiplier';
          setSortDrop('none');
        }
        if(filter === 'price'){
          sortName.innerHTML= 'Sort by : Rental Price';
          setSortDrop('none');
        }
        if(filter === 'term'){
          sortName.innerHTML= 'Sort by : Rental Term';
          setSortDrop('none');
        }
        if(filter === 'wearable'){
          sortName.innerHTML= 'Sort by : Wearable For Rent ';
          setSortDrop('none');
        }
      })
    }
  })
  
  return (
    <>
      <DashContainer id='container' degree={degree} >

        <WalletConnect />


          <Page>
            
              <Dash>
                <Wrapper>
                <Left>
                    <DashLogo src={image} />
                    <LeftCaption>
                      <Link>
                        {t("dashboardNav.left.leftCaption")}
                      </Link>
                      </LeftCaption>
                </Left>
                <Right>
                  <ResponsiveDashBar />
                    <ProfileInfo>
                          <WalletAddress>Mpzi8uaA......yMv</WalletAddress>
                          {t("page5.profileCard.connected")}
                      </ProfileInfo>
                    <DashIcons>
                    <LinkIcon id='account' onClick={Click}>
                      <DashIconContainer>
                        <Account />
                      </DashIconContainer>
                      </LinkIcon>
                      <LinkIcon onClick={RentalClick}>
                        <DashIconContainer>
                            <Rentals/>
                        </DashIconContainer>
                      </LinkIcon>
                      <LinkIcon onClick={MessageClick}>
                        <DashIconContainer>
                              <Message/>
                        </DashIconContainer>
                      </LinkIcon>
                      <LinkIcon onClick={NotificationIconClick}>
                        <NotificationIcon />
                      </LinkIcon>
                    </DashIcons>
                </Right>
              </Wrapper>
            </Dash>
            <DashContent>
                <DashHead>
                  <DashHeadCaption>
                  {t("dashboardHead.caption.text")} 
                  </DashHeadCaption>                
                </DashHead>
                <DashSelectWrapper>
                  <DashInputWrapper>                  
                    <DashInput onClick={SortClick} >
                      <DashInputText id='sortName'>Sort by : Wearable For Rent</DashInputText>
                      <DashInputImg rotate={rotate} src={arrow}/>
                    </DashInput>
                    <DashOptionWrapper display={sortDrop}>
                      <DashInputOption className='sort' value='wearable' >{t("dashboardSelect.option.text1")}</DashInputOption>
                      <DashInputOption className='sort' value='level'>{t("dashboardSelect.option.text3")}</DashInputOption>
                      <DashInputOption className='sort' value='multiplier'>{t("dashboardSelect.option.text4")}</DashInputOption>
                      <DashInputOption className='sort' value='price'>{t("dashboardSelect.option.text5")}</DashInputOption>
                      <DashInputOption className='sort' value='term'>{t("dashboardSelect.option.text6")}</DashInputOption>
                    </DashOptionWrapper>
                  </DashInputWrapper>
                  <DashSelectRight>           
                  <ExportTable 
                    table="table"
                    filename="tablexls"
                    sheet="tablexls"
                    buttonText= 'Export To Excel' />
                    <Pdf targetRef={ref} filename="code-example.pdf">
                    {({ toPdf }) => <ExportPdf onClick={toPdf}>Export To Pdf</ExportPdf>}
                  </Pdf>
                  </DashSelectRight>
                </DashSelectWrapper>
                <DashTable ref={ref}>
                <Content  sortTable={sortTable} rentals={TableRentClick}   />
                </DashTable>
            </DashContent>

          </Page>

      </DashContainer>
          <ProfileCard display={display} />
          <RentalsPopup display = {rentalsDisplay}/>
          <Notifications display={notificationDisplay} />
          <EmailPopup display= {messageDisplay} Cancel={CancelMessage}/>
          <RentPopup display ={rentsDisplay} Cancel= {CancelRentals}/>
        
      </>
  
  )
};

export default Page6;
